import { authRoles } from 'app/auth';
import StatusEditForm from './editform/StatusEditForm';
import StatusTable from './table/StatusTable';

export default [
	{
		path: '/status/edit/:id',
		component: StatusEditForm,
		auth: authRoles.userAccount
	},
	{
		path: '/status/:sessionNameParam?',
		component: StatusTable,
		auth: authRoles.userAccount
	}
];
